import React, { useState } from 'react';
import styles from './css/EventsPage.module.css';

import pic1 from '../../assets/events/DSC_0286.JPG';
import pic2 from '../../assets/events/DSC_0287.JPG';
import pic3 from '../../assets/events/DSC_0388.JPG';
import pic4 from '../../assets/events/DSC_0722.JPG';
import pic5 from '../../assets/events/DSC_0657.JPG';
import pic6 from '../../assets/events/DSC_0169.JPG';
import pic7 from '../../assets/events/DSC_0186.JPG';
import pic8 from '../../assets/events/DSC_0233.JPG';
import pic9 from '../../assets/events/DSC_0162.JPG';
import pic10 from '../../assets/events/DSC_0238.JPG';
import pic11 from '../../assets/events/DSC_0240.JPG';
import pic12 from '../../assets/events/DSC_0243.JPG';
import pic13 from '../../assets/events/DSC_0650.JPG';
import pic14 from '../../assets/events/IMG_2584.JPG';
import pic15 from '../../assets/events/DSC_0265.JPG';
import pic16 from '../../assets/events/DSC_0633.JPG';
import pic17 from '../../assets/events/DSC_0797.JPG';
import pic18 from '../../assets/events/DSC_0819.JPG';
import pic19 from '../../assets/events/DSC_0785.JPG';
import pic20 from '../../assets/events/DSC_0720.JPG';
import pic21 from '../../assets/events/IMG_2490.JPG';
import pic22 from '../../assets/events/IMG_2520.JPG';
import pic23 from '../../assets/events/IMG_2523.JPG';
import pic24 from '../../assets/events/IMG_2551.JPG';
import pic25 from '../../assets/events/IMG_3016.JPG';
import pic26 from '../../assets/events/DSC_0781.JPG';
import pic27 from '../../assets/events/IMG_3074a.jpg';
import pic28 from '../../assets/events/PIIT15 (1).jpg';
import pic29 from '../../assets/events/PIIT15 (2).jpg';
import pic30 from '../../assets/events/PIIT15 (3).jpg';
import pic31 from '../../assets/events/PIIT15 (4).jpg';
import pic32 from '../../assets/events/PIIT15 (5).jpg';
import pic33 from '../../assets/events/PIIT15 (6).jpg';
import pic34 from '../../assets/events/PIIT15 (7).jpg';
import pic35 from '../../assets/events/PIIT15 (8).jpg';
import pic36 from '../../assets/events/PIIT15 (9).jpg';
import pic37 from '../../assets/events/PIIT15 (10).jpg';
import pic38 from '../../assets/events/PIIT15 (11).jpg';
import pic39 from '../../assets/events/PIIT15 (12).jpg';
import pic40 from '../../assets/events/PIIT15 (13).jpg';
import pic41 from '../../assets/events/PIIT15 (14).jpg';
import pic42 from '../../assets/events/PIIT15 (15).jpg';
import pic43 from '../../assets/events/PIIT15 (16).jpg';
import pic44 from '../../assets/events/PIIT15 (17).jpg';
import pic45 from '../../assets/events/PIIT15 (18).jpg';
import pic46 from '../../assets/events/PIIT15 (19).jpg';
import pic47 from '../../assets/events/PIIT15 (20).jpg';
import pic48 from '../../assets/events/graduation2024 (1).JPG';
import pic49 from '../../assets/events/graduation2024 (2).JPG';
import pic50 from '../../assets/events/graduation2024 (3).JPG';
import pic51 from '../../assets/events/graduation2024 (4).JPG';
import pic52 from '../../assets/events/graduation2024 (5).JPG';
import pic53 from '../../assets/events/graduation2024 (6).JPG';
import pic54 from '../../assets/events/graduation2024 (7).JPG';
import pic55 from '../../assets/events/graduation2024 (8).JPG';
import pic56 from '../../assets/events/graduation2024 (9).JPG';
import pic57 from '../../assets/events/graduation2024 (10).JPG';
import pic58 from '../../assets/events/graduation2024 (11).JPG';
import pic59 from '../../assets/events/graduation2024 (12).JPG';
import pic60 from '../../assets/events/graduation2024 (13).JPG';
import pic61 from '../../assets/events/graduation2024 (14).JPG';
import pic62 from '../../assets/events/graduation2024 (15).JPG';
import pic63 from '../../assets/events/graduation2024 (16).JPG';
import pic64 from '../../assets/events/graduation2024 (17).JPG';
import pic65 from '../../assets/events/graduation2024 (18).JPG';
import pic66 from '../../assets/events/graduation2024 (19).JPG';
import pic67 from '../../assets/events/graduation2024 (20).JPG';
import pic68 from '../../assets/events/graduation2024 (21).JPG';
import pic69 from '../../assets/events/graduation2024 (22).JPG';
import pic70 from '../../assets/events/graduation2024 (23).JPG';
import pic71 from '../../assets/events/graduation2024 (24).JPG';
import pic72 from '../../assets/events/graduation2024 (25).JPG';
import pic73 from '../../assets/events/graduation2024 (26).JPG';
import pic74 from '../../assets/events/graduation2024 (27).JPG';
import pic75 from '../../assets/events/graduation2024 (28).JPG';
import pic76 from '../../assets/events/TAF (1).JPG';
import pic77 from '../../assets/events/TAF (2).JPG';
import pic78 from '../../assets/events/TAF (3).JPG';
import pic79 from '../../assets/events/TAF (4).JPG';
import pic80 from '../../assets/events/TAF (5).JPG';
import pic81 from '../../assets/events/TAF (6).JPG';
import pic82 from '../../assets/events/TAF (7).JPG';
import pic83 from '../../assets/events/TAF (8).JPG';
import pic84 from '../../assets/events/TAF (9).JPG';
import pic85 from '../../assets/events/TAF (10).JPG';
import pic86 from '../../assets/events/TAF (11).JPG';
import pic87 from '../../assets/events/TAF (12).JPG';
import pic88 from '../../assets/events/TAF (13).JPG';
import pic89 from '../../assets/events/TAF (14).JPG';
import pic90 from '../../assets/events/TAF (15).JPG';
import pic91 from '../../assets/events/TAF (16).JPG';
import pic92 from '../../assets/events/TAF (17).JPG';
import pic93 from '../../assets/events/TAF (18).JPG';
import pic94 from '../../assets/events/TAF (19).JPG';
import pic95 from '../../assets/events/TAF (20).JPG';
import pic96 from '../../assets/events/TAF (21).JPG';
import pic97 from '../../assets/events/TAF (22).JPG';
import pic98 from '../../assets/events/TAF (23).JPG';
import pic99 from '../../assets/events/TAF (24).JPG';
import pic100 from '../../assets/events/TAF (25).JPG';
import pic101 from '../../assets/events/TAF (27).JPG';
import pic102 from '../../assets/events/TAF (28).JPG';
import pic103 from '../../assets/events/TAF (29).JPG';
import pic104 from '../../assets/events/TAF (30).JPG';
import pic105 from '../../assets/events/TAF (31).JPG';
import pic106 from '../../assets/events/TAF (32).JPG';
import pic107 from '../../assets/events/TAF (33).JPG';
import pic108 from '../../assets/events/TAF (34).JPG';
import pic109 from '../../assets/events/TAF (35).JPG';
import pic110 from '../../assets/events/TAF (36).JPG';
import pic111 from '../../assets/events/TAF (26).JPG';
import pic112 from '../../assets/events/TAF (27).JPG';
import pic113 from '../../assets/events/TAF (28).JPG';
import pic114 from '../../assets/events/TAF (29).JPG';
import pic115 from '../../assets/events/TAF (30).JPG';
import pic116 from '../../assets/events/TAF (31).JPG';
import pic117 from '../../assets/events/TAF (32).JPG';
import pic118 from '../../assets/events/TAF (33).JPG';
import pic119 from '../../assets/events/TAF (34).JPG';
import pic120 from '../../assets/events/TAF (35).JPG';
import pic121 from '../../assets/events/TAF (36).JPG';
import pic122 from '../../assets/events/TAF (37).JPG';
import pic123 from '../../assets/events/TAF (38).JPG';
import pic124 from '../../assets/events/TAF (39).JPG';
import pic125 from '../../assets/events/TAF (40).JPG';
import pic126 from '../../assets/events/TAF (41).JPG';
import pic127 from '../../assets/events/TAF (42).JPG';
import pic128 from '../../assets/events/TAF (43).JPG';
import pic129 from '../../assets/events/TAF (44).JPG';
import pic130 from '../../assets/events/TAF (45).JPG';
import pic131 from '../../assets/events/TAF (46).JPG';
import pic132 from '../../assets/events/TAF (47).JPG';
import pic133 from '../../assets/events/TAF (48).JPG';
import pic134 from '../../assets/events/TAF (49).JPG';
import pic135 from '../../assets/events/TAF (50).JPG';
import pic136 from '../../assets/events/TAF (51).JPG';
import pic137 from '../../assets/events/TAF (52).JPG';
import pic138 from '../../assets/events/TAF (53).JPG';


const categories = ['Career Quest', 'Graduation Ceremony', 'PIIT @15', 'Tech Awareness Fest'];

const events = [
    { id: 1, title: 'Graduation 2021', imageUrl: pic1, category: 'Graduation Ceremony' },
    { id: 2, title: 'Career Quest 2019', imageUrl: pic2, category: 'Career Quest' },
    { id: 3, title: 'Graduation 2021', imageUrl: pic3, category: 'Graduation Ceremony' },
    { id: 4, title: 'Career Quest 2019', imageUrl: pic4, category: 'Career Quest' },
    { id: 5, title: 'Career Quest 2019', imageUrl: pic5, category: 'Career Quest' },
    { id: 6, title: 'Graduation 2021', imageUrl: pic6, category: 'Graduation Ceremony' },
    { id: 7, title: 'Graduation 2021', imageUrl: pic7, category: 'Graduation Ceremony' },
    { id: 8, title: 'Graduation 2021 Most Outstanding Student Award', imageUrl: pic8, category: 'Graduation Ceremony' },
    { id: 9, title: 'Graduation 2021', imageUrl: pic9, category: 'Graduation Ceremony' },
    { id: 10, title: 'Career Quest 2022', imageUrl: pic10, category: 'Career Quest' },
    { id: 11, title: 'Career Quest 2022', imageUrl: pic11, category: 'Career Quest' },
    { id: 12, title: 'Career Quest 2022', imageUrl: pic12, category: 'Career Quest' },
    { id: 13, title: 'Career Quest 2022', imageUrl: pic13, category: 'Career Quest' },
    { id: 14, title: 'CQ 2022 Scholarship Recipients', imageUrl: pic14, category: 'Career Quest' },
    { id: 15, title: 'CQ 2021 Scholarship Recipients', imageUrl: pic15, category: 'Career Quest' },
    { id: 16, title: 'Director with MD/CEO Aptech International', imageUrl: pic16, category: 'Career Quest' },
    { id: 17, title: 'Miss Aptech Lekki 2019', imageUrl: pic17, category: 'Career Quest' },
    { id: 18, title: 'Career Quest 2019 Middlesex University Representative', imageUrl: pic18, category: 'Career Quest' },
    { id: 19, title: 'Career Quest 2019 Award', imageUrl: pic19, category: 'Career Quest' },
    { id: 20, title: 'CQ 2019 Project Presentation', imageUrl: pic20, category: 'Career Quest' },
    { id: 21, title: 'CQ 2019 Middlesex University Presentation', imageUrl: pic21, category: 'Career Quest' },
    { id: 22, title: 'Career Quest 2022', imageUrl: pic22, category: 'Career Quest' },
    { id: 23, title: 'Career Quest 2022', imageUrl: pic23, category: 'Career Quest' },
    { id: 24, title: 'Career Quest 2023 Aptech India Representative', imageUrl: pic24, category: 'Career Quest' },
    { id: 25, title: 'Career Quest 2023', imageUrl: pic25, category: 'Career Quest' },
    { id: 26, title: 'Winner (Codathon Team 2019)', imageUrl: pic26, category: 'Career Quest' },
    { id: 27, title: 'Career Quest', imageUrl: pic27, category: 'Career Quest' },
    { id: 28, title: 'PIIT @ 15', imageUrl: pic28, category: 'PIIT @15' },
    { id: 29, title: 'PIIT @ 15', imageUrl: pic29, category: 'PIIT @15' },
    { id: 30, title: 'PIIT @ 15', imageUrl: pic30, category: 'PIIT @15' },
    { id: 31, title: 'PIIT @ 15', imageUrl: pic31, category: 'PIIT @15' },
    { id: 32, title: 'PIIT @ 15', imageUrl: pic32, category: 'PIIT @15' },
    { id: 33, title: 'PIIT @ 15', imageUrl: pic33, category: 'PIIT @15' },
    { id: 34, title: 'PIIT @ 15', imageUrl: pic34, category: 'PIIT @15' },
    { id: 35, title: 'PIIT @ 15', imageUrl: pic35, category: 'PIIT @15' },
    { id: 36, title: 'PIIT @ 15', imageUrl: pic36, category: 'PIIT @15' },
    { id: 37, title: 'PIIT @ 15', imageUrl: pic37, category: 'PIIT @15' },
    { id: 38, title: 'PIIT @ 15', imageUrl: pic38, category: 'PIIT @15' },
    { id: 39, title: 'PIIT @ 15', imageUrl: pic39, category: 'PIIT @15' },
    { id: 40, title: 'PIIT @ 15', imageUrl: pic40, category: 'PIIT @15' },
    { id: 41, title: 'PIIT @ 15', imageUrl: pic41, category: 'PIIT @15' },
    { id: 42, title: 'PIIT @ 15', imageUrl: pic42, category: 'PIIT @15' },
    { id: 43, title: 'PIIT @ 15', imageUrl: pic43, category: 'PIIT @15' },
    { id: 44, title: 'PIIT @ 15', imageUrl: pic44, category: 'PIIT @15' },
    { id: 45, title: 'PIIT @ 15', imageUrl: pic45, category: 'PIIT @15' },
    { id: 46, title: 'PIIT @ 15', imageUrl: pic46, category: 'PIIT @15' },
    { id: 47, title: 'PIIT @ 15', imageUrl: pic47, category: 'PIIT @15' },
    { id: 48, title: 'Graduation 2024', imageUrl: pic48, category: 'Graduation Ceremony' },
    { id: 49, title: 'Graduation 2024', imageUrl: pic49, category: 'Graduation Ceremony' },
    { id: 50, title: 'Graduation 2024', imageUrl: pic50, category: 'Graduation Ceremony' },
    { id: 51, title: 'Graduation 2024', imageUrl: pic51, category: 'Graduation Ceremony' },
    { id: 52, title: 'Graduation 2024', imageUrl: pic52, category: 'Graduation Ceremony' },
    { id: 53, title: 'Graduation 2024', imageUrl: pic53, category: 'Graduation Ceremony' },
    { id: 54, title: 'Graduation 2024', imageUrl: pic54, category: 'Graduation Ceremony' },
    { id: 55, title: 'Graduation 2024', imageUrl: pic55, category: 'Graduation Ceremony' },
    { id: 56, title: 'Graduation 2024', imageUrl: pic56, category: 'Graduation Ceremony' },
    { id: 57, title: 'Graduation 2024', imageUrl: pic57, category: 'Graduation Ceremony' },
    { id: 58, title: 'Graduation 2024', imageUrl: pic58, category: 'Graduation Ceremony' },
    { id: 59, title: 'Graduation 2024', imageUrl: pic59, category: 'Graduation Ceremony' },
    { id: 60, title: 'Graduation 2024', imageUrl: pic60, category: 'Graduation Ceremony' },
    { id: 61, title: 'Graduation 2024', imageUrl: pic61, category: 'Graduation Ceremony' },
    { id: 62, title: 'Graduation 2024', imageUrl: pic62, category: 'Graduation Ceremony' },
    { id: 63, title: 'Graduation 2024', imageUrl: pic63, category: 'Graduation Ceremony' },
    { id: 64, title: 'Graduation 2024', imageUrl: pic64, category: 'Graduation Ceremony' },
    { id: 65, title: 'Graduation 2024', imageUrl: pic65, category: 'Graduation Ceremony' },
    { id: 66, title: 'Graduation 2024', imageUrl: pic66, category: 'Graduation Ceremony' },
    { id: 67, title: 'Graduation 2024', imageUrl: pic67, category: 'Graduation Ceremony' },
    { id: 68, title: 'Graduation 2024', imageUrl: pic68, category: 'Graduation Ceremony' },
    { id: 69, title: 'Graduation 2024', imageUrl: pic69, category: 'Graduation Ceremony' },
    { id: 70, title: 'Graduation 2024', imageUrl: pic70, category: 'Graduation Ceremony' },
    { id: 71, title: 'Graduation 2024', imageUrl: pic71, category: 'Graduation Ceremony' },
    { id: 72, title: 'Graduation 2024', imageUrl: pic72, category: 'Graduation Ceremony' },
    { id: 73, title: 'Graduation 2024', imageUrl: pic73, category: 'Graduation Ceremony' },
    { id: 74, title: 'Graduation 2024', imageUrl: pic74, category: 'Graduation Ceremony' },
    { id: 75, title: 'Graduation 2024', imageUrl: pic75, category: 'Graduation Ceremony' },
    { id: 76, title: 'TAF1.0', imageUrl: pic76, category: 'Tech Awareness Fest' },
    { id: 77, title: 'TAF1.0', imageUrl: pic77, category: 'Tech Awareness Fest' },
    { id: 78, title: 'TAF1.0', imageUrl: pic78, category: 'Tech Awareness Fest' },
    { id: 79, title: 'TAF1.0', imageUrl: pic79, category: 'Tech Awareness Fest' },
    { id: 80, title: 'TAF1.0', imageUrl: pic80, category: 'Tech Awareness Fest' },
    { id: 81, title: 'TAF1.0', imageUrl: pic81, category: 'Tech Awareness Fest' },
    { id: 82, title: 'TAF1.0', imageUrl: pic82, category: 'Tech Awareness Fest' },
    { id: 83, title: 'TAF1.0', imageUrl: pic83, category: 'Tech Awareness Fest' },
    { id: 84, title: 'TAF1.0', imageUrl: pic84, category: 'Tech Awareness Fest' },
    { id: 85, title: 'TAF1.0', imageUrl: pic85, category: 'Tech Awareness Fest' },
    { id: 86, title: 'TAF1.0', imageUrl: pic86, category: 'Tech Awareness Fest' },
    { id: 87, title: 'TAF1.0', imageUrl: pic87, category: 'Tech Awareness Fest' },
    { id: 88, title: 'TAF1.0', imageUrl: pic88, category: 'Tech Awareness Fest' },
    { id: 89, title: 'TAF1.0', imageUrl: pic89, category: 'Tech Awareness Fest' },
    { id: 90, title: 'TAF1.0', imageUrl: pic90, category: 'Tech Awareness Fest' },
    { id: 91, title: 'TAF1.0', imageUrl: pic91, category: 'Tech Awareness Fest' },
    { id: 92, title: 'TAF1.0', imageUrl: pic92, category: 'Tech Awareness Fest' },
    { id: 93, title: 'TAF1.0', imageUrl: pic93, category: 'Tech Awareness Fest' },
    { id: 94, title: 'TAF1.0', imageUrl: pic94, category: 'Tech Awareness Fest' },
    { id: 95, title: 'TAF1.0', imageUrl: pic95, category: 'Tech Awareness Fest' },
    { id: 96, title: 'TAF1.0', imageUrl: pic96, category: 'Tech Awareness Fest' },
    { id: 97, title: 'TAF1.0', imageUrl: pic97, category: 'Tech Awareness Fest' },
    { id: 98, title: 'TAF1.0', imageUrl: pic98, category: 'Tech Awareness Fest' },
    { id: 99, title: 'TAF1.0', imageUrl: pic99, category: 'Tech Awareness Fest' },
    { id: 100, title: 'TAF1.0', imageUrl: pic100, category: 'Tech Awareness Fest' },
    { id: 101, title: 'TAF1.0', imageUrl: pic101, category: 'Tech Awareness Fest' },
    { id: 102, title: 'TAF1.0', imageUrl: pic102, category: 'Tech Awareness Fest' },
    { id: 103, title: 'TAF1.0', imageUrl: pic103, category: 'Tech Awareness Fest' },
    { id: 104, title: 'TAF1.0', imageUrl: pic104, category: 'Tech Awareness Fest' },
    { id: 105, title: 'TAF1.0', imageUrl: pic105, category: 'Tech Awareness Fest' },
    { id: 106, title: 'TAF1.0', imageUrl: pic106, category: 'Tech Awareness Fest' },
    { id: 107, title: 'TAF1.0', imageUrl: pic107, category: 'Tech Awareness Fest' },
    { id: 108, title: 'TAF1.0', imageUrl: pic108, category: 'Tech Awareness Fest' },
    { id: 109, title: 'TAF1.0', imageUrl: pic109, category: 'Tech Awareness Fest' },
    { id: 110, title: 'TAF1.0', imageUrl: pic110, category: 'Tech Awareness Fest' },
    { id: 111, title: 'TAF1.0', imageUrl: pic111, category: 'Tech Awareness Fest' },
    { id: 112, title: 'TAF1.0', imageUrl: pic112, category: 'Tech Awareness Fest' },
    { id: 113, title: 'TAF1.0', imageUrl: pic113, category: 'Tech Awareness Fest' },
    { id: 114, title: 'TAF1.0', imageUrl: pic114, category: 'Tech Awareness Fest' },
    { id: 115, title: 'TAF1.0', imageUrl: pic115, category: 'Tech Awareness Fest' },
    { id: 116, title: 'TAF1.0', imageUrl: pic116, category: 'Tech Awareness Fest' },
    { id: 117, title: 'TAF1.0', imageUrl: pic117, category: 'Tech Awareness Fest' },
    { id: 118, title: 'TAF1.0', imageUrl: pic118, category: 'Tech Awareness Fest' },
    { id: 119, title: 'TAF1.0', imageUrl: pic119, category: 'Tech Awareness Fest' },
    { id: 120, title: 'TAF1.0', imageUrl: pic120, category: 'Tech Awareness Fest' },
    { id: 121, title: 'TAF1.0', imageUrl: pic121, category: 'Tech Awareness Fest' },
    { id: 122, title: 'TAF1.0', imageUrl: pic122, category: 'Tech Awareness Fest' },
    { id: 123, title: 'TAF1.0', imageUrl: pic123, category: 'Tech Awareness Fest' },
    { id: 124, title: 'TAF1.0', imageUrl: pic124, category: 'Tech Awareness Fest' },
    { id: 125, title: 'TAF1.0', imageUrl: pic125, category: 'Tech Awareness Fest' },
    { id: 126, title: 'TAF1.0', imageUrl: pic126, category: 'Tech Awareness Fest' },
    { id: 127, title: 'TAF1.0', imageUrl: pic127, category: 'Tech Awareness Fest' },
    { id: 128, title: 'TAF1.0', imageUrl: pic128, category: 'Tech Awareness Fest' },
    { id: 129, title: 'TAF1.0', imageUrl: pic129, category: 'Tech Awareness Fest' },
    { id: 130, title: 'TAF1.0', imageUrl: pic130, category: 'Tech Awareness Fest' },
    { id: 131, title: 'TAF1.0', imageUrl: pic131, category: 'Tech Awareness Fest' },
    { id: 132, title: 'TAF1.0', imageUrl: pic132, category: 'Tech Awareness Fest' },
    { id: 133, title: 'TAF1.0', imageUrl: pic133, category: 'Tech Awareness Fest' },
    { id: 134, title: 'TAF1.0', imageUrl: pic134, category: 'Tech Awareness Fest' },
    { id: 135, title: 'TAF1.0', imageUrl: pic135, category: 'Tech Awareness Fest' },
    { id: 136, title: 'TAF1.0', imageUrl: pic136, category: 'Tech Awareness Fest' },
    { id: 137, title: 'TAF1.0', imageUrl: pic137, category: 'Tech Awareness Fest' },
    { id: 138, title: 'TAF1.0', imageUrl: pic138, category: 'Tech Awareness Fest' },
];

const EventsPage = () => {
    const [activeCategory, setActiveCategory] = useState('Career Quest');
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [modalImage, setModalImage] = useState(null);
    const itemsPerPage = 8;

    const filteredEvents = events
        .filter(event => event.category === activeCategory)
        .filter(event => event.title.toLowerCase().includes(searchTerm.toLowerCase()));

    const totalPages = Math.ceil(filteredEvents.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentEvents = filteredEvents.slice(startIndex, startIndex + itemsPerPage);

    const handlePageChange = (direction) => {
        setCurrentPage(prev => {
            if (direction === 'prev') return Math.max(prev - 1, 1);
            if (direction === 'next') return Math.min(prev + 1, totalPages);
        });
    };

    const handleTabChange = (category) => {
        setActiveCategory(category);
        setCurrentPage(1);
        setSearchTerm('');
    };

    return (
        <div>
            <div className={styles.tabs}>
                {categories.map(category => (
                    <button
                        key={category}
                        className={`${styles.tab} ${activeCategory === category ? styles.active : ''}`}
                        onClick={() => handleTabChange(category)}
                    >
                        {category}
                    </button>
                ))}
            </div>

            <div className={styles.searchBar}>
                <input
                    type="text"
                    placeholder="Search events..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            <div className={styles.eventsContainer}>
                {currentEvents.map(event => (
                    <div key={event.id} className={styles.eventCard} onClick={() => setModalImage(event)}>
                        <img src={event.imageUrl} alt={event.title} className={styles.eventImage} />
                        <h3 className={styles.eventTitle}>{event.title}</h3>
                    </div>
                ))}
            </div>

            {filteredEvents.length > itemsPerPage && (
                <div className={styles.pagination}>
                    <button onClick={() => handlePageChange('prev')} disabled={currentPage === 1}>Prev</button>
                    <span>Page {currentPage} of {totalPages}</span>
                    <button onClick={() => handlePageChange('next')} disabled={currentPage === totalPages}>Next</button>
                </div>
            )}

            {modalImage && (
                <div className={styles.modal} onClick={() => setModalImage(null)}>
                    <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
                        <img src={modalImage.imageUrl} alt={modalImage.title} />
                        <h3>{modalImage.title}</h3>
                        <button onClick={() => setModalImage(null)}>Close</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EventsPage;
